module.exports = __webpack_public_path__ + "static/media/20-off-v2.23d5d750.svg";